/**
 * Created by Zhaoyp on 20250728
 */

import request from "@/libs/request";

// Modern API endpoint
const API_UPLOAD_BASE = '/api/upload/';

// Expect an object like { file: File } and send as 'listFile' to match backend
const uploadListFile = ({ file }) => {
	const postData = {
		data: {
            listFile: file,
		},
        multipart: true
	};
	return request(`${API_UPLOAD_BASE}list`, postData);
};

// New: partial upload endpoint expects JSON body with rows array
const partialUpload = ({ rows }) => {
  const postData = {
    data: { rows: JSON.stringify(rows) },
    // Send as urlencoded body per ajax util; backend uses express.json and urlencoded
  };
  return request(`${API_UPLOAD_BASE}partial`, postData);
};

// Analyze CSV data and check for existing records
const analyzeCSV = ({ rows }) => {
  const postData = {
    data: { rows: JSON.stringify(rows) },
  };
  return request(`${API_UPLOAD_BASE}analyze`, postData);
};

// Upload single row (for progress tracking)
const uploadSingleRow = async (row) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${API_UPLOAD_BASE}partial`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ rows: [row] }),
  });
  return response.json();
};

export default {
    uploadListFile,
    partialUpload,
    analyzeCSV,
    uploadSingleRow,
};